var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"container"},[_c('el-row',[_c('el-col',{attrs:{"span":11}},[_c('HomeInfoCard')],1),_c('el-col',{attrs:{"span":11,"offset":1}},[_c('CreditStatusCard')],1)],1)],1):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }